<template>
  <q-btn
          v-if="isGranted('ADD_PAYMENT_METHOD')"
          icon="fa fa-plus"
          label="Add Payment Method"
          v-bind="$attrs"
          @click="openModal"
  />
</template>

<script lang="ts">
import { defineComponent } from 'vue';
import isGranted from '@/auth/isGranted';
import { PaymentMethod } from '@/type';
import openModal from '@/components/modal';
import AddPaymentMethodModal from './AddPaymentMethodModal.vue';

export default defineComponent({
  emits: ['added'],
  props: {
    customerId: {
      type: Number,
      required: true,
    },
  },
  methods: {
    openModal() {
      const props = { customerId: this.customerId };
      openModal(AddPaymentMethodModal, props).onOk((paymentMethod: PaymentMethod) => {
        this.$emit('added', paymentMethod);
      });
    },
    isGranted,
  },
});
</script>
